import type { Project } from "@shared/types";

// Project picker. With `includeAll`, adds an "All projects" option whose value is
// the string "all" (for portfolio-wide views).
export default function ProjectSelector({
  projects,
  value,
  onChange,
  includeAll = false,
}: {
  projects: Project[];
  value: number | "all" | null;
  onChange: (id: number | "all") => void;
  includeAll?: boolean;
}) {
  return (
    <label className="flex items-center gap-2 text-sm text-ink-500">
      <span>Project</span>
      <select
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value === "all" ? "all" : Number(e.target.value))}
        className="rounded-lg border border-ink-300 bg-white px-3 py-1.5 text-sm font-medium text-ink-900 focus-ring"
      >
        {includeAll && <option value="all">All projects</option>}
        {projects.map((p) => (
          <option key={p.id} value={p.id}>
            {p.name}
            {p.hasDetail ? "" : " · summary only"}
          </option>
        ))}
      </select>
    </label>
  );
}
